export function formatDateRu(value, fallback = "—") {
    if (value == null || value === "") return fallback;
    const raw = String(value).trim();
    if (!raw) return fallback;

    // YYYY-MM-DD
    const isoDate = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDate) {
        const [, y, m, d] = isoDate;
        return `${d}.${m}.${y}`;
    }

    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) return raw;

    return parsed.toLocaleDateString("ru-RU");
}

export function formatDateTimeRu(value, fallback = "—") {
    if (value == null || value === "") return fallback;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return String(value);

    return parsed.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

export function replaceIsoDatesInText(text) {
    if (text == null) return text;
    return String(text).replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, (_, y, m, d) => `${d}.${m}.${y}`);
}
